import { Box, Flex, FlexProps } from '@chakra-ui/react'

import EmptyDraftIllustration from 'src/assets/illustration/CuratedByMeNoDraftItlistsSVG'

type EmptyStateProps = {
  Image?: React.FC
  icon?: JSX.Element
  hideImage?: boolean
  title: string
  body?: string | JSX.Element
  action?: JSX.Element
  border?: string
} & FlexProps

const EmptyState = ({
  Image = () => <EmptyDraftIllustration />,
  icon,
  hideImage: hideImage = false,
  title = 'Nothing here yet...',
  border = '1px solid',
  body,
  action,
  ...props
}: EmptyStateProps) => {
  return (
    <Flex
      direction="column"
      border={border}
      borderColor="sandstonePlus"
      borderRadius={12}
      alignItems="center"
      justifyContent="center"
      py={10}
      gap={3}
      {...props}
    >
      {!hideImage && <Image />}
      {!!icon && icon}

      <Box
        as="h5"
        whiteSpace="pre-line"
        className="thick"
        data-testid="emptyState"
      >
        {title}
      </Box>

      {body && (
        <Box
          color="stone"
          whiteSpace="pre-line"
          className="body-extra-small"
          textAlign="center"
          mt={1}
          px={6}
          maxW="500px"
        >
          {body}
        </Box>
      )}

      {!!action && (
        <>
          <Box mt={3}>{action}</Box>
        </>
      )}
    </Flex>
  )
}

export default EmptyState
